import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { Loader2, ShieldAlert } from 'lucide-react';

export const RequireAdmin: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 dark:bg-[#020617] text-slate-500">
        <Loader2 className="w-8 h-8 text-[#0ea5e9] animate-spin mb-4" />
        <span className="text-sm font-medium animate-pulse">Verifying privileges...</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAdmin) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 dark:bg-[#020617] text-center px-6">
        <div className="w-16 h-16 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center mb-6">
          <ShieldAlert className="w-8 h-8 text-red-500" />
        </div>
        <h1 className="text-4xl font-bold text-slate-900 dark:text-white mb-4">403 Forbidden</h1>
        <p className="text-slate-600 dark:text-slate-400 mb-8 max-w-md">
          You do not have the required permissions to access the HenselX Admin Console.
          This attempt has been logged.
        </p>
        <a href="/" className="text-[#0ea5e9] hover:text-[#0284c7] font-medium transition-colors">Return to Safety</a>
      </div>
    );
  }

  return <>{children}</>;
};
